export const FormatDecimal = (num, digits)=> Number(num).toFixed(digits);
